import { createSlice, current } from "@reduxjs/toolkit";
const initialState = { previousPath: ["dashboard"] };


const breadCrumbReducer = createSlice({
    name: "breadCrumbReducer",
    initialState,
    reducers: {
        breadCrumbroutes: (state, action) => {
            let indexvalue = state.previousPath.indexOf(action.payload)
                if (indexvalue != undefined && indexvalue != -1) {
                    state.previousPath.splice(indexvalue)
                    state.previousPath.push(action.payload)
                }
                if (indexvalue != undefined && indexvalue == -1) {
                    state.previousPath.push(action.payload)
                }
        },
        breadCrumbroutesDelete: (state, action) => {
            if(action.payload!== "logout")
            {state.previousPath = []
            state.previousPath.push(action.payload)}
        },

    },
});

export const { breadCrumbroutes, breadCrumbroutesDelete } = breadCrumbReducer.actions;
export default breadCrumbReducer.reducer;